import { Component, computed, inject, input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { map, filter, startWith, switchMap } from 'rxjs';

import { CmsCollection, CmsContent, CmsTemplate } from '@fcom/core-api';
import { safeMap } from '@fcom/core/utils/utils';
import { SelectOption } from '@fcom/common/interfaces/form-interface';

@Component({
  selector: 'cms-content-switcher-dropdown',
  templateUrl: './cms-content-switcher-dropdown.component.html',
  styleUrls: ['./cms-content-switcher-dropdown.component.scss'],
  standalone: false,
})
export class CmsContentSwitcherDropdownComponent {
  private fb = inject(UntypedFormBuilder);

  content = input.required<CmsCollection>();

  readonly contentOptions = computed<SelectOption[]>(() => {
    return this.content().items.map((ct) => {
      return {
        name: ct.teaserTitle,
        value: ct.teaserTitle,
      };
    });
  });

  readonly contentForm = computed<UntypedFormGroup>(() => {
    const items = this.content().items;
    if (items.length === 0) {
      return undefined;
    }

    return this.fb.group({ content: safeMap(items[0], (i) => i.teaserTitle) });
  });

  readonly selectedContent = toSignal<CmsTemplate>(
    toObservable(this.contentForm).pipe(
      filter(Boolean),
      switchMap((contentForm) => {
        const contentControl = contentForm.get('content');
        return contentControl.valueChanges.pipe(startWith(contentControl.value));
      }),
      map((selectedContent) => {
        return this.content().items.find((item: CmsContent) => item.teaserTitle === selectedContent);
      }),
      filter(Boolean),
      map((template) => {
        return {
          header: null,
          main: [template as CmsCollection],
          footer: null,
        };
      })
    )
  );
}
